<template>
    <div class="stl-kinput" :class="{ off: disabled }">
        <span class="cur">₩</span>
        <input
            type="text"
            inputmode="numeric"
            autocomplete="off"
            :value="display"
            :disabled="disabled"
            :placeholder="placeholder"
            @input="onInput"
            @keyup.enter="$emit('enter')"
        />
    </div>
</template>

<script>
import { formatWonInput, parseWonInput } from "../utils/settlementFormat.js";

export default {
    name: "AmountKinput",
    props: {
        /** 숫자 또는 null (v-model) */
        value: { type: [Number, String], default: null },
        disabled: { type: Boolean, default: false },
        placeholder: { type: String, default: "예: 1,000,000" },
    },
    computed: {
        display() {
            return formatWonInput(this.value);
        },
    },
    methods: {
        onInput(e) {
            const next = parseWonInput(e.target.value);
            this.$emit("input", next);
            // :value 바인딩이 콤마를 다시 그리므로 커서 보정
            this.$nextTick(() => {
                const el = e.target;
                if (!el) return;
                const len = el.value.length;
                try {
                    el.setSelectionRange(len, len);
                } catch (_) {
                    /* ignore */
                }
            });
        },
    },
};
</script>
